/**
 * ============================================================================
 * CRUNCHMASTER MAIN JAVASCRIPT FILE
 * ============================================================================
 * 
 * Main entry point for all JavaScript functionality across the Crunchmaster 
 * THFoods website. This file contains various interactive features including
 * navigation, UI enhancements, and user experience improvements.
 * 
 * Dependencies: jQuery, Bootstrap 5
 * ============================================================================
 */

// ============================================================================
// IMPORTS & DEPENDENCIES
// ============================================================================
import $ from "jquery";
const jQuery = $;

// ============================================================================
// DOM CLEANUP - REMOVE EMPTY PARAGRAPHS
// ============================================================================
/**
 * Clean up empty paragraph tags that may be left by the CMS
 * Removes paragraphs that contain only whitespace or &nbsp; entities
 */
$("p").each(function () {
    var $this = $(this);
    if ($this.html().replace(/\s|&nbsp;/g, "").length == 0) $this.remove();
});

// ============================================================================
// MAIN UI COMPONENTS & INTERACTIONS
// ============================================================================
$(document).ready(function () {
    
    // ========================================================================
    // NAVIGATION - BOOTSTRAP 5 DROPDOWN KEYBOARD ACCESSIBILITY
    // ========================================================================
    /**
     * Enhanced keyboard navigation for Bootstrap 5 dropdowns
     * Provides different behavior for mobile vs desktop
     * Ensures accessibility compliance for screen readers
     */
    $('.dropdown-toggle').on('keydown', function(e) {
        // Check if we're on mobile and in a mobile-only container
        const isMobile = window.innerWidth < 992;
        const isMobileOnly = $(this).closest('.mobile-only').length > 0;
        
        if (isMobile && isMobileOnly) {
            // Mobile behavior: Focus first dropdown item instead of toggling
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const firstDropdownItem = $(this).siblings('.dropdown-menu').find('.dropdown-item:first');
                if (firstDropdownItem.length) {
                    firstDropdownItem.focus();
                }
            }
        } else {
            // Desktop behavior: Standard Bootstrap dropdown functionality
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                $(this).click(); // Trigger Bootstrap's dropdown functionality
            }
            // Handle Escape key to close dropdown
            if (e.key === 'Escape') {
                const dropdown = bootstrap.Dropdown.getInstance(this);
                if (dropdown) {
                    dropdown.hide();
                }
            }
        }
    });

    // ========================================================================
    // NAVIGATION - REMOVE DUPLICATE ACTIVE CLASSES
    // ========================================================================
    /**
     * Ensure only ONE menu item has the 'active' class per dropdown menu
     * If multiple items have active class, keep only the first one
     * Removes active from both <li> and <a> elements
     */
    $('.dropdown-menu').each(function() {
        const $dropdownMenu = $(this);
        const $activeItems = $dropdownMenu.find('li.active');
        
        // If there's more than one active item, remove active from all except the first
        if ($activeItems.length > 1) {
            $activeItems.slice(1).each(function() {
                $(this).removeClass('active');
                $(this).find('a').removeClass('active');
            });
        }
    });

    // ========================================================================
    // FAQ ACCORDION SYSTEM
    // ========================================================================
    /**
     * Custom FAQ accordion functionality with enhanced UX
     * Features:
     * - One FAQ open at a time (accordion behavior)
     * - Smooth icon rotation animations
     * - Proper ARIA attributes for accessibility
     */
    $('.wholesale-faq-accordion .faq-toggle').on('click', function(e) {
        e.preventDefault();
        
        var $this = $(this);
        var target = $this.attr('data-bs-target');
        var $target = $(target);
        
        // Close all other open FAQs
        $('.wholesale-faq-accordion .faq-answer').not($target).removeClass('show');
        $('.wholesale-faq-accordion .faq-toggle').not($this).attr('aria-expanded', 'false');
        $('.wholesale-faq-accordion .faq-icon i').not($this.find('.faq-icon i')).css('transform', 'rotate(0deg)');
        
        // Toggle the clicked FAQ
        if ($target.hasClass('show')) {
            // Close current FAQ
            $target.removeClass('show');
            $this.attr('aria-expanded', 'false');
            $this.find('.faq-icon i').css('transform', 'rotate(0deg)');
        } else {
            // Open current FAQ
            $target.addClass('show');
            $this.attr('aria-expanded', 'true');
            $this.find('.faq-icon i').css('transform', 'rotate(180deg)');
        }
    });

    // ========================================================================
    // DYNAMIC BUTTON STYLING - TAXONOMY-BASED THEMING
    // ========================================================================
    /**
     * Automatically applies button styling based on parent section's taxonomy
     * Only affects buttons with just the base 'btn' class (no existing btn-* classes)
     * 
     * Product taxonomy styling:
     * - multi-seed: Secondary button with product class
     * - avocado-toast: Primary button
     * - multi-grain: Primary button with product class  
     * - crisps: Secondary button
     * - default: Primary button
     */
    $('.btn').each(function() {
        var $btn = $(this);
        
        // Only apply styling if the button only has 'btn' class (no other btn-* classes)
        if ($btn.attr('class') === 'btn' || $btn.hasClass('btn') && !$btn.is('[class*="btn-"]')) {
            var $parentSection = $btn.closest('[class*="-section"], .category-card');
            
            // Apply styling based on parent section's taxonomy class
            if ($parentSection.hasClass('multi-seed')) {

                $btn.addClass('border-purple');

            } else if ($parentSection.hasClass('avocado-toast')) {

                $btn.addClass('border-purple');

            } else if ($parentSection.hasClass('multi-grain')) {

                $btn.addClass('border-yellow');

            } else if ($parentSection.hasClass('crisps')) {

                $btn.addClass('border-purple');
                
            } else {
                // Default fallback styling
                $btn.addClass('btn-primary');
            }
        }
    });

});

// ============================================================================
// PRODUCT GALLERY & NAVIGATION FEATURES
// ============================================================================
$(document).ready(function() {
    
    
    // ========================================================================
    // CONTACT FORM TABS - ENHANCED NAVIGATION & SMOOTH SCROLLING
    // ========================================================================
    /**
     * Enhanced tab navigation for contact forms with smooth scrolling
     * Features:
     * - Smooth scroll to contact form section when tab is clicked
     * - Automatic tab activation from URL hash parameters
     * - Deep linking support for direct tab access
     * - Maintains Bootstrap tab functionality
     */
    
    // Handle tab clicks with smooth scrolling (delegated so dynamically added tabs work)
    $(document).on('click', '[data-element-name="contact-forms"] [role="tab"][data-bs-toggle="tab"]', function() {
        // Ensure the Bootstrap tab actually toggles even if markup is non-standard
        if (typeof bootstrap !== 'undefined' && bootstrap.Tab) {
            bootstrap.Tab.getOrCreateInstance(this).show();
        }

        // Small delay to allow tab to activate first
        setTimeout(function() {
            var $contactFormsContainer = $('[data-element-name="contact-forms"]');

            if ($contactFormsContainer.length > 0) {
                // Calculate dynamic offset based on main header height + 20px buffer
                var $mainHeader = $('header, .main-header, #main-header, [data-element-name="mainheader"], [data-element-id="mainheader"]').first();
                var headerHeight = $mainHeader.length ? $mainHeader.outerHeight() : 0;
                var offset = headerHeight + 20;

                // Smooth scroll to the contact forms section
                $('html, body').animate({
                    scrollTop: $contactFormsContainer.offset().top - offset
                }, 500);
            }
        }, 50);
    });
    
    // Handle direct tab access via URL hash on page load
    $(window).on('load', function() {
        var hash = window.location.hash;
        if (hash) {
            // Dynamically discover tab mappings by scanning existing tabs
            var tabMappings = buildTabMappings();
            
            var targetTab = tabMappings[hash.toLowerCase()];
            if (targetTab) {
                // Activate the target tab
                $(targetTab).tab('show');
                
                // Scroll to contact forms section after a brief delay
                setTimeout(function() {
                    var $contactFormsContainer = $('[data-element-name="contact-forms"]');
                    if ($contactFormsContainer.length > 0) {
                        var $mainHeader = $('header, .main-header, #main-header, [data-element-name="mainheader"], [data-element-id="mainheader"]').first();
                        var headerHeight = $mainHeader.length ? $mainHeader.outerHeight() : 0;
                        var offset = headerHeight + 20;
                        
                        $('html, body').animate({
                            scrollTop: $contactFormsContainer.offset().top - offset
                        }, 500);
                    }
                }, 100);
            }
        }
    });
    
    /**
     * Dynamically builds tab mappings by scanning existing tabs in the DOM
     * This eliminates the need to manually update mappings when adding new tabs
     * 
     * @returns {Object} Hash-to-tab mappings object
     */
    function buildTabMappings() {
        var mappings = {};
        
        // Find all tab elements with role="tab" within contact forms section
        $('[data-element-name="contact-forms"] [role="tab"]').each(function() {
            var $tab = $(this);
            var tabId = $tab.attr('id');
            var tabText = $tab.text().toLowerCase().trim();
            
            if (tabId && tabText) {
                // Create multiple hash mappings for each tab based on common variations
                var baseName = tabText.replace(/\s+/g, '-');
                
                // Primary mapping (e.g., #general -> #general-tab)
                mappings['#' + baseName] = '#' + tabId;
                
                // Common variations
                mappings['#' + baseName + '-inquiry'] = '#' + tabId;
                mappings['#' + baseName + '-concern'] = '#' + tabId;
                mappings['#' + baseName + '-tab'] = '#' + tabId;
                
                // Handle specific known aliases
                if (baseName === 'general') {
                    mappings['#customer'] = '#' + tabId;
                    mappings['#customer-concern'] = '#' + tabId;
                }
                
                // For retail/customer tabs - common aliases
                if (baseName === 'retail') {
                    mappings['#customer'] = '#' + tabId;
                    mappings['#customer-concern'] = '#' + tabId;
                }
            }
        });
        
        return mappings;
    }

    // ========================================================================
    // SMOOTH SCROLL NAVIGATION - ENHANCED ANCHOR LINK HANDLING
    // ========================================================================
    /**
     * Enhanced smooth scrolling for internal anchor links
     * Features:
     * - Supports data-element-id and data-element-name attributes
     * - Falls back to standard id attributes
     * - Dynamic header height calculation for proper offset
     * - Instant scroll (no animation) for better UX
     * - Excludes tab buttons to prevent conflicts
     * 
     * Priority order:
     * 1. data-element-id
     * 2. data-element-name  
     * 3. Standard id attribute
     */
    
    /**
     * Helper function to find target element by hash
     * Checks data-element-id, data-element-name, and regular id
     * 
     * @param {string} target - The target identifier (without #)
     * @returns {jQuery} - jQuery object of target element (may be empty)
     */
    function findTargetElement(target) {
        if (!target) return $();
        
        // Try to find target element by data-element-id first
        var $targetElement = $('[data-element-id="' + target + '"]');
        
        // If not found, try data-element-name
        if ($targetElement.length === 0) {
            $targetElement = $('[data-element-name="' + target + '"]');
        }
        
        // If still not found, try regular id attribute as fallback
        if ($targetElement.length === 0) {
            $targetElement = $('#' + target);
        }
        
        return $targetElement;
    }
    
    /**
     * Helper function to scroll to a target element
     * 
     * @param {jQuery} $targetElement - The element to scroll to
     */
    function scrollToElement($targetElement) {
        if ($targetElement.length > 0) {
            // Calculate dynamic offset based on main header height + 20px buffer
            var $mainHeader = $('header, .main-header, #main-header, [data-element-name="mainheader"], [data-element-id="mainheader"]').first();
            var headerHeight = $mainHeader.length ? $mainHeader.outerHeight() : 0;
            var offset = headerHeight + 20;
            
            // Jump directly to target (instant scroll for better UX)
            $('html, body').scrollTop($targetElement.offset().top - offset);
        }
    }

    function normalizePathname(pathname) {
        if (!pathname) return '/';
        return pathname.replace(/\/+$/, '') || '/';
    }

    function getHashFromHref(href) {
        if (!href) return '';
        var hashIndex = href.indexOf('#');
        if (hashIndex === -1) return '';
        return href.substring(hashIndex);
    }

    function isSamePageHref(href) {
        if (!href || href.charAt(0) === '#') return true;

        try {
            var url = new URL(href, window.location.href);
            return url.origin === window.location.origin
                && normalizePathname(url.pathname) === normalizePathname(window.location.pathname);
        } catch (err) {
            return false;
        }
    }

    function scrollToHash(hash, delay) {
        if (!hash || hash.length < 2 || hash === '#') return;

        var target = hash.substring(1);
        var isContactFormTab = $('[data-element-name="contact-forms"] [role="tab"]#' + target).length > 0;
        if (isContactFormTab) return;

        var $targetElement = findTargetElement(target);
        if ($targetElement.length === 0) return;

        if (delay) {
            setTimeout(function() {
                scrollToElement($targetElement);
            }, delay);
            return;
        }

        scrollToElement($targetElement);
    }

    // Same-page hash clicks, including full URLs like /blog/#blog-all
    $(document).on('click', 'a[href*="#"]', function(e) {
        var $link = $(this);
        if ($link.is('[role="tab"], [data-bs-toggle="tab"]')) return;

        var href = $link.attr('href');
        var hash = getHashFromHref(href);
        if (!hash || hash === '#' || !isSamePageHref(href)) return;

        var $targetElement = findTargetElement(hash.substring(1));
        if ($targetElement.length === 0) return;

        e.preventDefault();
        scrollToElement($targetElement);

        if (window.location.hash !== hash) {
            history.pushState(null, '', hash);
        }
    });

    // Back/forward and same-page hash changes (no reload)
    $(window).on('hashchange', function() {
        scrollToHash(window.location.hash);
    });
    
    // Handle deep linking from other pages (hash in URL on page load)
    $(window).on('load', function() {
        scrollToHash(window.location.hash, 100);
    });
    
});

// ============================================================================
// HEADER SCROLL BEHAVIOR - FADE ON SCROLL
// ============================================================================
$(document).ready(function() {
    
    /**
     * Scroll-based header fade functionality for medium screens and up
     * Features:
     * - Fades out header when scrolled down more than 200px
     * - Fades back in immediately when scrolling up
     * - Only active on md breakpoint and above (768px+)
     * - Smooth opacity transition
     */
    let isHeaderHidden = false;
    let lastScrollTop = 0;
    const $header = $('header#mainheader');
    
    $(window).on('scroll', function() {
        // Only apply on medium screens and up
        if (window.innerWidth >= 768) {
            const scrollTop = $(window).scrollTop();
            const isScrollingUp = scrollTop < lastScrollTop;
            
            if (scrollTop > 200 && !isScrollingUp && !isHeaderHidden) {
                // Fade out header when scrolling down past 200px
                $header.addClass('header-hidden');
                isHeaderHidden = true;
            } else if ((isScrollingUp || scrollTop <= 150) && isHeaderHidden) {
                // Fade in header when scrolling up or when near top
                $header.removeClass('header-hidden');
                isHeaderHidden = false;
            }
            
            // Update last scroll position
            lastScrollTop = scrollTop;
        } else {
            // On mobile, ensure header is always visible
            if ($header.hasClass('header-hidden')) {
                $header.removeClass('header-hidden');
                isHeaderHidden = false;
            }
        }
    });
    
    // Reset header visibility on window resize
    $(window).on('resize', function() {
        if (window.innerWidth < 768) {
            if ($header.hasClass('header-hidden')) {
                $header.removeClass('header-hidden');
                isHeaderHidden = false;
            }
        }
    });
    
});

// ============================================================================
// MOBILE BR TAG REMOVAL - SPECIFIC ELEMENT HANDLING
// ============================================================================
$(document).ready(function() {
    
    /**
     * Remove br tags inside p tags for mobile devices (sm breakpoint and down)
     * Specifically targets the crunchmaster-newproduct-cta element
     * Features:
     * - Only applies on mobile devices (576px and below)
     * - Targets specific element with data-element-id="crunchmaster-newproduct-cta"
     * - Removes br tags inside p tags within that element
     * - Handles window resize to reapply/remove changes
     */
    
    function handleMobileBrTags() {
        const $targetElement = $('[data-element-id="crunchmaster-newproduct-cta"]');
        
        if ($targetElement.length > 0) {
            if (window.innerWidth <= 576) {
                // Mobile: Remove br tags inside p tags
                $targetElement.find('p br').remove();
            }
            // Note: We don't restore br tags on desktop resize since they're already removed
            // The original content will be preserved on page refresh
        }
    }
    
    // Apply on page load
    handleMobileBrTags();
    
    // Reapply on window resize
    $(window).on('resize', function() {
        handleMobileBrTags();
    });
    
});

// ============================================================================
// ALLERGEN HIGHLIGHTING - ADD CLASS TO SESAME ITEMS
// ============================================================================
$(document).ready(function() {
    
    /**
     * Find and highlight list items containing "Contains Sesame" text
     * Adds a specific class for styling purposes
     * Uses case-insensitive matching for better reliability
     */
    $('ul li').filter(function() {
        return $(this).text().toLowerCase().indexOf('contains sesame') !== -1;
    }).addClass('contains-sesame');
    
});

// ============================================================================
// NUTRITION FACTS - DAILY VALUE ALIGNMENT FIX
// ============================================================================
$(document).ready(function() {
    
    /**
     * Fix alignment for "% Daily Value" rows in nutrition facts tables
     * Changes justify-content-between to justify-content-end for proper alignment
     * Targets list items containing "Daily Value" text
     */
    $('li').filter(function() {
        return $(this).text().indexOf('Daily Value') !== -1;
    }).find('.justify-content-between').removeClass('justify-content-between').addClass('justify-content-end');
    
});


// ============================================================================
// CONTACT FORM 7 - ENSURE REQUIRED ELEMENTS EXIST
// ============================================================================
$(document).ready(function() {
    
    /**
     * Ensure Contact Form 7 has all required DOM elements to prevent errors
     * Fixes: "Cannot set properties of null (setting 'innerText')" error
     * 
     * Note: jQuery must be available globally (via jquery-global.js) for this
     * and Contact Form 7 to work properly. The bundle includes jQuery and makes
     * it available as window.jQuery and window.$.
     * 
     * Contact Form 7 expects:
     * - .wpcf7-response-output elements for displaying messages
     * - .screen-reader-response [role="status"] for screen reader messages
     * 
     * If these don't exist, the plugin will throw errors when trying to set innerText
     */
    
    // Ensure jQuery is available (should be set by jquery-global.js)
    // If jQuery isn't available, Contact Form 7 won't work, so exit early
    if (typeof window.jQuery === 'undefined') {
        return;
    }
    
    function ensureContactForm7Elements() {
        // Find all Contact Form 7 forms
        $('.wpcf7 > form').each(function() {
            var $form = $(this);
            var $wpcf7Container = $form.closest('.wpcf7');
            
            // Ensure response output element exists
            if ($form.find('.wpcf7-response-output').length === 0) {
                $form.append('<div class="wpcf7-response-output" aria-hidden="true"></div>');
            }
            
            // Ensure screen reader response element exists
            var $screenReaderResponse = $wpcf7Container.find('.screen-reader-response');
            if ($screenReaderResponse.length === 0) {
                // Create the screen-reader-response structure
                var $screenReaderDiv = $('<div class="screen-reader-response" aria-live="polite" aria-atomic="true"></div>');
                var $statusElement = $('<div role="status"></div>');
                var $ul = $('<ul></ul>');
                $screenReaderDiv.append($statusElement);
                $screenReaderDiv.append($ul);
                $wpcf7Container.prepend($screenReaderDiv);
            } else {
                // Ensure the [role="status"] element exists within screen-reader-response
                if ($screenReaderResponse.find('[role="status"]').length === 0) {
                    // Add a [role="status"] element if it doesn't exist
                    $screenReaderResponse.prepend('<div role="status"></div>');
                }
                // Ensure ul exists for error messages
                if ($screenReaderResponse.find('ul').length === 0) {
                    $screenReaderResponse.append('<ul></ul>');
                }
            }
        });
    }
    
    // Run on page load
    ensureContactForm7Elements();
    
    // Also run after a short delay to catch dynamically loaded forms
    setTimeout(ensureContactForm7Elements, 500);
    
    // Watch for new forms added dynamically
    if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function(mutations) {
            var shouldCheck = false;
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length > 0) {
                    for (var i = 0; i < mutation.addedNodes.length; i++) {
                        var node = mutation.addedNodes[i];
                        if (node.nodeType === 1) { // Element node
                            if ($(node).hasClass('wpcf7') || $(node).find('.wpcf7').length > 0) {
                                shouldCheck = true;
                                break;
                            }
                        }
                    }
                }
            });
            if (shouldCheck) {
                setTimeout(ensureContactForm7Elements, 100);
            }
        });
        
        // Observe the document body for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    
});


